import {
    Socials,
    SupportedAssets,
    SupportedChains,
    SupportedConnectors,
} from '../../config/constants';

// socials
import Discord from './social/Discord';
import Telegram from './social/Telegram';
import Twitter from './social/Twitter';
import Medium from './social/Medium';
import Gitbook from './social/Gitbook';
import LinkedIn from './social/LinkedIn';

// assets
import Usdc from './tokens/Usdc';
import Usdt from './tokens/Usdt';
import Dai from './tokens/Dai';

//chains
import Arbitrum from './chains/Arbirtrum';
import Ethereum from './chains/Ethereum';

// connectors
import Metamask from './connectors/Metamask';
import WalletConnect from './connectors/WalletConnect';
import Coinbase from './connectors/Coinbase';
import Trezor from './connectors/Trezor';
import Portis from './connectors/Portis';
import Ledger from './connectors/Ledger';
import Torus from './connectors/Torus';
import Fortmatic from './connectors/Fortmatic';
import UAuth from './connectors/UAuth';
import TokenFallback from './tokens/TokenFallback';
import Bitkeep from './connectors/Bitkeep';
import Nabox from './connectors/Nabox';
import FoxWallet from './connectors/FoxWallet';
import OKX from './connectors/OKX';

// modal
export { default as CrossIcon } from './modal/Cross';
export { default as ConnectWalletIcon } from './modal/ConnectWallet';
export { default as ErrorModalIcon } from './modal/Error';
export { default as SuccessIcon } from './modal/Success';
export { default as WarningIcon } from './modal/Warning';
export { default as NotificationModalIcon } from './modal/Notification';
export { default as SpinnerWaitingIcon } from './modal/Spinner';

// general
export { default as AddIcon } from './general/Add';
export { default as CheckboxTickIcon } from './general/CheckboxTick';
export { default as DarkThemeIcon } from './general/DarkTheme';
export { default as LightThemeIcon } from './general/LightTheme';
export { default as FilterIcon } from './general/Filter';
export { default as ErrorIcon } from './general/Error';
export { default as NotificationIcon } from './general/Notification';
export { default as UserIcon } from './general/User';
export { default as SearchIcon } from './general/Search';
export { default as WalletIcon } from './general/Wallet';
export { default as CopyRoundedIcon } from './general/CopyRounded';
export { default as InfoRoundedIcon } from './general/InfoRounded';

// arrows
export { default as ArrowDownIcon } from './arrows/ArrowDown';
export { default as FooterArrowIcon } from './arrows/FooterArrow';
export { default as StepButtonArrowIcon } from './arrows/StepButtonArrow';
export { default as StepButtonArrowLongIcon } from './arrows/StepButtonArrowLong';
export { default as IncentivizedArrowIcon } from './arrows/IncentivizedArrow';

type Icons = {
    [x: string]: JSX.Element;
};

export const SocialIcons: Icons = {
    [Socials.DISCORD]: Discord(),
    [Socials.TELEGRAM]: Telegram(),
    [Socials.TWITTER]: Twitter(),
    [Socials.MEDIUM]: Medium(),
    [Socials.GITBOOK]: Gitbook(),
    [Socials.LINKEDIN]: LinkedIn(),
};

export const AssetIcons: Icons = {
    [SupportedAssets.DAI]: Dai(),
    [SupportedAssets.USDC]: Usdc(),
    [SupportedAssets.USDT]: Usdt(),
    [SupportedAssets.FALLBACK]: TokenFallback(),
};

export const WalletConnectorIcons: Icons = {
    [SupportedConnectors.METAMASK]: Metamask(),
    [SupportedConnectors.WALLET_CONNECT]: WalletConnect(),
    [SupportedConnectors.COINBASE]: Coinbase(),
    [SupportedConnectors.TREZOR]: Trezor(),
    [SupportedConnectors.PORTIS]: Portis(),
    [SupportedConnectors.LEDGER]: Ledger(),
    [SupportedConnectors.TORUS]: Torus(),
    [SupportedConnectors.FORTMATIC]: Fortmatic(),
    [SupportedConnectors.UAUTH]: UAuth(),
    [SupportedConnectors.BITKEEP]: Bitkeep(),
    [SupportedConnectors.NABOX]: Nabox(),
    [SupportedConnectors.FOX]: FoxWallet(),
    [SupportedConnectors.OKX]: OKX(),
};

export const ChainIcons: Icons = {
    [SupportedChains.MAINNET]: Ethereum(),
    [SupportedChains.ARBITRUM_ONE]: Arbitrum(),
};
